<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";
	import registrationTypes from "../../config/registrationTypes";
	import { registerPageComplete, getTealiumID } from "../../tealium";

	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import YesNoUnsureGroup from "../../components/YesNoUnsureGroup.svelte";
	import DatePicker from "../../components/DatePicker.svelte";
	import TextArea from "../../components/TextArea.svelte";
	import TextInput from "../../components/TextInput.svelte";
	import NumberInput from "../../components/NumberInput.svelte";
	import RadioGroup from "../../components/RadioGroup.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import SaveAndClose from "../../components/SaveAndClose.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import DefaultFundDetails from "../../components/DefaultFundDetails.svelte";

	export let disabled = null;
	export let pageName = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let required = true;
	let buttons = null;

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		$model.tealiumId = $model.tealiumId || getTealiumID();
	}

	const RebaseData = () => {
		if ($model.defaultSignUpByEmployer && $model.defaultSignUpByEmployer !== "Yes") {
			$model.employerName = null;
		}

		if ($model.haveOtherDefaultSuperFunds && $model.haveOtherDefaultSuperFunds !== "Yes") {
			$model.otherDefaultSuperFunds = [];
		}
	};

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(response);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);
				RebaseData();
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const initialise = () => {};

	initialise();

	let beenMememberLabel = "";
	let notMemberLabel = "";
	let memberNumberLabel = "";
	let defaultSignUpByEmployerLabel = "";
	let haveRestSuperFundInsuranceLabel = "";
	let haveIncomeProtectionInsuranceLabel = "";
	let haveOtherDefaultSuperFundsLabel = "";
	$: {
		if ($model.registrationType) {
			if ($model.registrationType === registrationTypes.types.Myself.value) {
				beenMememberLabel = "Have you ever been a member of Rest Superannuation?";
				notMemberLabel =
					"If you were not a member of Rest Superannuation you are not eligible to register for the class action.";
				memberNumberLabel = "What was/is your Rest Superannuaton member number?";
				defaultSignUpByEmployerLabel = "Were you signed up to Rest Superannuation by default by your employer?";
				haveRestSuperFundInsuranceLabel = "Did you have any insurance through your Rest super fund?";
				haveIncomeProtectionInsuranceLabel = "Did you have income protection insurance?";
				haveOtherDefaultSuperFundsLabel = "Were you signed up to any other default super funds by employers?";
			} else {
				beenMememberLabel = "Have they ever been a member of Rest Superannuation?";
				notMemberLabel =
					"If they were not a member of Rest Superannuation they are not eligible to register for the class action.";
				memberNumberLabel = "What was/is their Rest Superannuaton member number?";
				defaultSignUpByEmployerLabel =
					"Were they signed up to Rest Superannuation by default by their employer?";
				haveRestSuperFundInsuranceLabel = "Did they have any insurance through their Rest super fund?";
				haveIncomeProtectionInsuranceLabel = "Did they have income protection insurance?";
				haveOtherDefaultSuperFundsLabel = "Were they signed up to any other default super funds by employers?";
			}
		}
	}
</script>

<PageSection>
	<Form {disabled} id="form-implant" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Policy Details</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<YesNoGroup
						{required}
						{disabled}
						name="beenMemember"
						label={beenMememberLabel}
						bind:value={$model.haveBeenRestSuperMember}
					/>
				</FormColumn>
			</FormRow>

			{#if $model.haveBeenRestSuperMember && $model.haveBeenRestSuperMember === "No"}
				<FormRow>
					<FormColumn>
						<div class="prompt">
							<p>
								Please note that at this time Shine Lawyers is only investigating members of Rest
								Superannuation.
							</p>
							<p>{notMemberLabel}</p>
						</div>
					</FormColumn>
				</FormRow>
			{:else if $model.haveBeenRestSuperMember && $model.haveBeenRestSuperMember === "Yes"}
				<FormRow>
					<FormColumn>
						<TextInput
							{disabled}
							label={memberNumberLabel}
							bind:value={$model.memberNumber}
							id="memberNumber"
						/>
					</FormColumn>
				</FormRow>

				<FormRow>
					<FormColumn>
						<YesNoUnsureGroup
							{required}
							{disabled}
							name="defaultSignUpByEmployer"
							label={defaultSignUpByEmployerLabel}
							bind:value={$model.defaultSignUpByEmployer}
						/>
					</FormColumn>
				</FormRow>
				{#if $model.defaultSignUpByEmployer && $model.defaultSignUpByEmployer === "Yes"}
					<FormRow>
						<FormColumn>
							<TextInput
								{disabled}
								label="Employer Name"
								bind:value={$model.employerName}
								id="employerName"
							/>
						</FormColumn>
					</FormRow>
				{/if}
				<FormRow>
					<FormColumn>
						<YesNoUnsureGroup
							{required}
							{disabled}
							name="haveRestSuperFundInsurance"
							label={haveRestSuperFundInsuranceLabel}
							bind:value={$model.haveRestSuperFundInsurance}
						/>
					</FormColumn>
				</FormRow>
				<FormRow>
					<FormColumn>
						<YesNoUnsureGroup
							{required}
							{disabled}
							name="haveIncomeProtectionInsurance"
							label={haveIncomeProtectionInsuranceLabel}
							bind:value={$model.haveIncomeProtectionInsurance}
						/>
					</FormColumn>
				</FormRow>
				<FormRow>
					<FormColumn>
						<YesNoUnsureGroup
							{required}
							{disabled}
							name="haveOtherDefaultSuperFunds"
							label={haveOtherDefaultSuperFundsLabel}
							bind:value={$model.haveOtherDefaultSuperFunds}
						/>
					</FormColumn>
				</FormRow>
				{#if $model.haveOtherDefaultSuperFunds && $model.haveOtherDefaultSuperFunds === "Yes"}
					<DefaultFundDetails {required} {disabled} bind:superFunds={$model.otherDefaultSuperFunds} />
				{/if}

				<FormRow class="confirmation-hide">
					<FormColumn class="last">
						<SaveAndClose>Save and Close</SaveAndClose>
					</FormColumn>
				</FormRow>

				<FormRow class="confirmation-hide">
					<FormColumn>
						<NavigationButtons
							bind:buttons
							nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"}
						/>
					</FormColumn>
				</FormRow>
			{/if}
		</div>
	</Form>
</PageSection>

<style>
	.prompt {
		border: solid 1px var(--color-alert-global);
		padding: 10px;
	}
</style>
